module.exports = __webpack_public_path__ + "media/media/product-card/software-link-3-a820fa221fd1715adb1ad80013bd7d60.png";